import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'secondsToTimePipe', standalone: true, pure: true })
export class SecondsToTimePipe implements PipeTransform {
  transform(totalSeconds: number): string {
    const seconds = Math.max(0, Math.floor(totalSeconds ?? 0));
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
